module.exports = "https://www.gc-qa.gnp.com.mx/2b6842804b846bf10c35e086ba6bc4d0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-registro-datos.svg
// module id = 1835
// module chunks = 0